<!--查验更改箱封号-->
<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SealNoChangeAdfterInspection')"
    width="500px"
    :close-on-click-modal="false"
    class="app-main-inner"
    append-to-body
  >

    <el-form label-width="60px" label-position="left">
      <el-form-item :label="$t('SeaExport.ContainerNo')">
        <el-input v-model="formData.containerNo" :disabled="true" no="1" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.SealNo')">
        <el-input v-model="formData.sealNo" no="2" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.AdditionalNotes')" />
      <el-form-item class="label-none custom">
        <el-input v-model="formData.remark" type="textarea" :rows="5" no="3" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" no="4" @click="onOK">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="5" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'SealNumberChangeDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    propFormData: { type: Object, required: false }
  },
  data() {
    return {
      innerVisible: false,
      formData: {} // 表单数据
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (this.visible) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.onShow()
    }
  },
  methods: {
    onShow() {
      this.formData = lodash.cloneDeep(this.propFormData)
    },
    onOK() {
      this.$emit('sealCloseHandler', this.formData)
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
